export const IconFilter = () => {
  return (
    <svg
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="37"
        height="36"
        rx="7"
        stroke="#053462"
        strokeWidth="2"
      />
      <path
        d="M27.833 14.417H22.833"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5003 14.417H11.167"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8337 17.3333C19.4445 17.3333 20.7503 16.0275 20.7503 14.4167C20.7503 12.8058 19.4445 11.5 17.8337 11.5C16.2228 11.5 14.917 12.8058 14.917 14.4167C14.917 16.0275 16.2228 17.3333 17.8337 17.3333Z"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8333 23.583H24.5"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.167 23.583H11.167"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1667 26.5003C22.7775 26.5003 24.0833 25.1945 24.0833 23.5837C24.0833 21.9728 22.7775 20.667 21.1667 20.667C19.5558 20.667 18.25 21.9728 18.25 23.5837C18.25 25.1945 19.5558 26.5003 21.1667 26.5003Z"
        stroke="#053462"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
